export default "/images/096253910e61c0042290e7eefd24dcef.avif";